import type React from 'react';

import { Divider, FormField, FormHelp, Label, LabeledControl, Switch } from '@zillow/constellation-10';

type Props = {
  children?: React.ReactNode;
  title: string;
  caption: string;
  switchTitle: string;
  switchedOn: boolean;
  toggleSwitch: () => void;
};

export default function AdditionalRulesTemplate({
  title,
  caption,
  switchTitle,
  switchedOn,
  toggleSwitch,
  children,
}: Props): JSX.Element {
  return (
    <>
      <FormField
        optional
        label={<Label>{title}</Label>}
        control={
          <LabeledControl
            fluid
            labelPosition="left"
            label={<Label>{switchTitle}</Label>}
            control={
              <Switch aria-label="Toggle additional rules" size="lg" checked={switchedOn} onChange={toggleSwitch} />
            }
          />
        }
        description={<FormHelp>{caption}</FormHelp>}
      />
      {children && <Divider css={{ marginTop: 'layout.tighter', marginBottom: 'layout.tighter' }} />}
      {children}
    </>
  );
}
